(function () {
  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  function measureNeedsToggle(wrap, content) {
    // Measure clamped height
    wrap.classList.remove("is-expanded");
    var clampedHeight = content.getBoundingClientRect().height;

    // Measure full height
    wrap.classList.add("is-expanded");
    var fullHeight = content.getBoundingClientRect().height;

    // Restore original state (do NOT force collapse)
    var wasExpanded = wrap.getAttribute("data-expanded") === "true";
    wrap.classList.toggle("is-expanded", wasExpanded);

    return fullHeight > clampedHeight + 2;
  }

  function initOne(wrap) {
    if (wrap.getAttribute("data-cr-init") === "1") return;

    var content = wrap.querySelector(".cr-collection-desc__content");
    var btn = wrap.querySelector(".cr-collection-desc__toggle");
    if (!content || !btn) return;

    wrap.setAttribute("data-cr-init", "1");

    // Apply lines from data attribute
    var lines = wrap.getAttribute("data-collapsed-lines") || "4";
    wrap.style.setProperty("--cr-lines", lines);

    // Default state
    wrap.setAttribute("data-expanded", "false");
    wrap.classList.remove("is-expanded");
    btn.setAttribute("aria-expanded", "false");
    btn.textContent = "Read more";

    // Click handler (bind once)
    btn.addEventListener("click", function () {
      var nowExpanded = wrap.getAttribute("data-expanded") !== "true";
      wrap.setAttribute("data-expanded", nowExpanded ? "true" : "false");
      wrap.classList.toggle("is-expanded", nowExpanded);
      btn.setAttribute("aria-expanded", nowExpanded ? "true" : "false");
      btn.textContent = nowExpanded ? "Read less" : "Read more";
    });
  }

  function updateVisibility(root) {
    root.querySelectorAll(".js-cr-collapsible").forEach(function (wrap) {
      var content = wrap.querySelector(".cr-collection-desc__content");
      var btn = wrap.querySelector(".cr-collection-desc__toggle");
      if (!content || !btn) return;

      // Desktop: always expanded, hide button
      if (!isMobile()) {
        wrap.classList.add("is-expanded");
        wrap.setAttribute("data-expanded", "true");
        btn.hidden = true;
        return;
      }

      // Mobile: decide if button is needed, but DO NOT reset expanded state
      requestAnimationFrame(function () {
        var needs = measureNeedsToggle(wrap, content);
        btn.hidden = !needs;

        var expanded = wrap.getAttribute("data-expanded") === "true";
        wrap.classList.toggle("is-expanded", expanded);
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
        btn.textContent = expanded ? "Read less" : "Read more";
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".js-cr-collapsible").forEach(initOne);
    updateVisibility(document);

    // IMPORTANT: don't listen to resize (mobile Safari triggers it on scroll)
    // Only update on orientation change (real layout change)
    window.addEventListener("orientationchange", function () {
      setTimeout(function () {
        updateVisibility(document);
      }, 250);
    });
  });
})();
